import React, {useEffect, useState} from 'react';
import {
  Dimensions,
  Image,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import {connect} from 'react-redux';
import {ALPHABET} from '../../../../src/data/constants/alphabet';
import {BREAKPOINT} from '../../../data/constants/screen';
import {ApiResponse} from '../../../data/types/interface/api';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../components/Header/HeaderScreen';
import {ListSimple} from '../../components/List/ListSimple/index.web';
import {Loader} from '../../components/Loader';
import {styles} from './styles.web';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function LexiqueScreen(props: any) {
  const {
    lexique: {listLexique},
    getLexique,
  } = props;

  const [listItem, setListItem] = useState(listLexique || []);
  const [svg, setSvg] = useState(listLexique || []);

  const [search, setSearch] = useState('');
  const [filteredDataSource, setFilteredDataSource] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const alphabet = ALPHABET;
  useEffect(() => {
    getLexique({}, (res: ApiResponse) => {
      setLoading(true);
      if (res && res.data) {
        let listItemtest = res.data && res.data.items;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        listItemtest = listItemtest.map((e: any) => {
          return {
            libelle: removeAccents(e.libelle),
            id: e.id,
          };
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        listItemtest.sort(function (a: any, b: any) {
          const nameA = a.libelle.toUpperCase(),
            nameB = b.libelle.toUpperCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });
        setSvg(listItemtest);
        setListItem(listItemtest);
        setFilteredDataSource(listItemtest);
        setLoading(false);
      }
    });
  }, []);

  const removeAccents = (value: string) => {
    return value
      .replace(/á/g, 'a')
      .replace(/é/g, 'e')
      .replace(/í/g, 'i')
      .replace(/ó/g, 'o')
      .replace(/ú/g, 'u')
      .replace(/â/g, 'a');
  };

  const searchFilterFunction = (text: string, checkText?: boolean) => {
    setLoading(true);
    if (text) {
      const newData = checkText
        ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
          listItem.filter(function (item: any) {
            const itemData = item.libelle
              ? item.libelle.toUpperCase()
              : ''.toUpperCase();
            const textData = text.toUpperCase();
            return itemData.indexOf(textData) > -1;
          })
        : // eslint-disable-next-line @typescript-eslint/no-explicit-any
          listItem.filter(function (item: any) {
            return item.libelle.charAt(0) === text;
          });

      setFilteredDataSource(newData);
      checkText ? setSearch(text) : setSearch('');
      setLoading(false);
    } else {
      setFilteredDataSource(listItem);
      checkText ? setSearch(text) : setSearch('');
      setLoading(false);
    }
  };

  const selectedElement = (element: string) => {
    element === 'Tous'
      ? setFilteredDataSource(svg)
      : searchFilterFunction(element, false);
  };

  const alphabetList = alphabet.map(element => (
    <TouchableOpacity key={element} onPress={() => selectedElement(element)}>
      <Text>{element}</Text>
    </TouchableOpacity>
  ));

  return (
    <View>
      <HeaderScreen title="Lexique" type="home" noBreadcrumb={false} />
      <View
        style={{
          backgroundColor: '#fff',
          maxWidth: 780,
          marginHorizontal: 'auto',
          marginTop: 0,
          marginBottom: 30,
          width: '100%',
          paddingHorizontal:
            Dimensions.get('window').width > BREAKPOINT.sm ? 100 : 20,
          paddingTop: 30,
          paddingBottom: 40,
        }}>
        <View style={{flexDirection: 'column'}}>
          <View style={styles.itemSearchStyle}>
            <Image
              style={styles.itemSearchIcone}
              // eslint-disable-next-line @typescript-eslint/no-require-imports
              source={require('../../../ressources/images/Search.png')}
            />
            <TextInput
              placeholder="Rechercher"
              style={styles.itemSearchInput}
              onChangeText={(text: string) => searchFilterFunction(text, true)}
              value={search}></TextInput>
          </View>
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: 16,
              marginVertical: 16,
              flexWrap: 'wrap',
              gap: Dimensions.get('window').width > BREAKPOINT.sm ? 0 : 16,
            }}>
            {alphabetList}
          </View>
          {isLoading && <Loader />}
          <ListSimple data={filteredDataSource} />
        </View>
      </View>
    </View>
  );
}

export const Lexique = connect(
  mapStateToProps,
  mapDispatchToProps,
)(LexiqueScreen);
